const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

const SHELL = (title, inner) => `<html><head><title>${esc(title)}</title><style>
  body{font-family:'Courier New',monospace;padding:14px;width:300px;color:#111}
  h2{text-align:center;margin:0}.sub{text-align:center;font-size:11px;color:#666;margin:2px 0 10px}
  table{width:100%;border-collapse:collapse;font-size:12px;margin-top:2px}
  .r{text-align:right}.ord{border-bottom:1px dashed #aaa;padding:8px 0}
  .oh{font-weight:bold;font-size:12px;margin-bottom:2px;display:flex;justify-content:space-between}
  .ot{font-size:11px;color:#444}.tag{font-size:9px;padding:1px 4px;border-radius:6px;font-weight:bold}
  .paid{background:#e6f4ea;color:#137333}.due{background:#fce8e6;color:#c5221f}
  .grand{font-weight:bold;text-align:right;margin-top:12px;font-size:15px;border-top:2px solid #111;padding-top:6px}
  .owed{text-align:right;font-size:13px;color:#c5221f;font-weight:bold;margin-top:4px}
  .sect{font-size:11px;font-weight:bold;text-transform:uppercase;letter-spacing:1px;color:#137333;margin:12px 0 4px;border-bottom:1px solid #ccc;padding-bottom:2px}
  .cat{font-size:12px;font-weight:bold;margin:8px 0 2px}
</style></head><body>${inner}
<script>window.onload=function(){window.print();}</script></body></html>`;

function openPrint(title, inner, w = 340) {
  const win = window.open("", "_blank", `width=${w},height=680`);
  if (!win) return;
  win.document.write(SHELL(title, inner));
  win.document.close();
}

export function printReceipt(title, orders) {
  if (!orders || orders.length === 0) return;
  const body = orders.map((o) => {
    const items = o.items.map((i) => {
      const extra = [(i.options || []).join(" · "), i.note ? `\u201c${i.note}\u201d` : ""].filter(Boolean).join(" \u2014 ");
      return `<tr><td>${i.qty}× ${esc(i.name)}${extra ? `<div style="font-size:10px;color:#555">${esc(extra)}</div>` : ""}</td><td class="r">${(i.price * i.qty).toFixed(2)}€</td></tr>`;
    }).join("");
    const stn = o.station === "kitchen" ? "Food" : o.station === "bar" ? "Drinks" : "Order";
    const pay = o.payment_method ? ` · ${esc(o.payment_method)}${o.payment_ref ? ` (${esc(o.payment_ref)})` : ""}` : "";
    const mark = o.invoiced ? `<span class="tag paid">PAID</span>` : `<span class="tag due">DUE</span>`;
    const allergy = o.allergies ? `<div style="color:#c5221f;font-weight:bold;font-size:11px;margin-top:3px">Allergies: ${esc(o.allergies)}</div>` : "";
    return `<div class="ord"><div class="oh"><span>${esc(o.spot_label)} · ${stn}${pay}</span>${mark}</div><table>${items}</table>${allergy}<div class="r ot">${o.total.toFixed(2)}€</div></div>`;
  }).join("");
  const total = orders.reduce((s, o) => s + o.total, 0);
  const owed = orders.filter((o) => !o.invoiced).reduce((s, o) => s + o.total, 0);
  const when = new Date().toLocaleString();
  const owedLine = owed > 0 ? `<div class="owed">UNPAID ${owed.toFixed(2)}€</div>` : "";
  openPrint("Receipt", `<h2>TRIBE Beach</h2><div class="sub">${esc(title)} · ${esc(when)}</div>${body}
    <div class="grand">TOTAL ${total.toFixed(2)}€</div>${owedLine}`);
}

export function printSalesRecap(date, data, week) {
  const money = (v) => `${(v || 0).toFixed(2)}€`;
  const rows = (arr) => (arr || []).map((r) => `<tr><td>${esc(r.name)}</td><td class="r">${money(r.total)}</td></tr>`).join("") || `<tr><td colspan="2" style="color:#999">—</td></tr>`;
  const food = data?.by_station?.kitchen || 0;
  const bar = data?.by_station?.bar || 0;
  const inner = `<h2>TRIBE Beach</h2><div class="sub">End-of-Day Recap · ${esc(date)}</div>
    <div class="ord"><div class="oh"><span>Revenue</span><span>${money(data?.total)}</span></div>
      <div class="ot">${data?.count || 0} orders</div></div>
    <div class="sect">Food vs Drinks</div>
    <table><tr><td>Food (kitchen)</td><td class="r">${money(food)}</td></tr>
      <tr><td>Drinks (bar)</td><td class="r">${money(bar)}</td></tr></table>
    <div class="sect">By payment method</div>
    <table>${rows(data?.by_payment)}</table>
    <div class="sect">By spot</div>
    <table>${rows(data?.by_spot)}</table>
    <div class="sect">Top categories</div>
    <table>${rows((data?.by_category || []).slice(0, 10))}</table>
    ${week ? `<div class="sect">Last 7 days</div><table><tr><td>Week total</td><td class="r">${money(week.total)}</td></tr><tr><td>Orders</td><td class="r">${week.count || 0}</td></tr></table>` : ""}
    <div class="grand">TOTAL ${money(data?.total)}</div>`;
  openPrint("End-of-Day Recap", inner);
}

export function printMenu(menu) {
  if (!menu || menu.length === 0) return;
  const sections = menu.filter((c) => (c.items || []).length > 0).map((cat) => {
    const rows = cat.items.map((it) => `<div class="mi"><span class="nm">${esc(it.name)}</span><span class="dots"></span><span class="pr">${it.price.toFixed(2)}€</span></div>`).join("");
    return `<section class="sec"><h2>${esc(cat.category)}</h2>${rows}</section>`;
  }).join("");
  const html = `<html><head><title>TRIBE Menu</title>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@300;500;600&family=Mulish:ital,wght@0,400;0,600;1,400&display=swap" rel="stylesheet">
    <style>
      :root{--bg:#F1ECE0;--ink:#34555E;--soft:#7d8f92}
      @page{size:A4;margin:16mm 18mm}
      *{box-sizing:border-box}
      html,body{margin:0;padding:0}
      body{background:var(--bg);color:var(--ink);font-family:'Mulish',-apple-system,Helvetica,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact}
      .wrap{max-width:640px;margin:0 auto;padding:8px 4px 40px}
      h1{font-family:'Oswald',sans-serif;font-weight:300;letter-spacing:.14em;text-transform:uppercase;text-align:center;font-size:46px;margin:8px 0 4px}
      .tag{text-align:center;font-size:11px;letter-spacing:.32em;text-transform:uppercase;color:var(--soft);margin-bottom:34px}
      .sec{margin:0 0 30px;break-inside:avoid}
      .sec h2{font-family:'Oswald',sans-serif;font-weight:600;letter-spacing:.1em;text-transform:uppercase;font-size:17px;margin:0 0 12px;border-bottom:1px solid rgba(52,85,94,.25);padding-bottom:6px}
      .mi{display:flex;align-items:baseline;gap:8px;margin:7px 0;font-size:14px}
      .nm{white-space:nowrap;font-weight:400}
      .dots{flex:1;border-bottom:1px dotted rgba(52,85,94,.35);transform:translateY(-3px)}
      .pr{white-space:nowrap;font-weight:600;font-variant-numeric:tabular-nums}
      .foot{text-align:center;margin-top:24px;font-family:'Oswald',sans-serif;font-weight:500;letter-spacing:.3em;text-transform:uppercase;font-size:12px;color:var(--soft)}
    </style></head>
    <body><div class="wrap">
      <h1>Tribe Menu</h1>
      <div class="tag">Beach Lounge · Tigaki, Kos</div>
      ${sections}
      <div class="foot">Tribe</div>
    </div>
    <script>window.onload=function(){setTimeout(function(){window.print();},350);}</script>
    </body></html>`;
  const win = window.open("", "_blank", "width=800,height=900");
  if (!win) return;
  win.document.write(html);
  win.document.close();
}
